/**
 * Screen Resize Service
 *
 */

import React from 'react'

export const { Consumer, Provider } = React.createContext(
  null,
  (oldProps, newProps) => {
    return ( oldProps.sw === newProps.sw && oldProps.sh === newProps.sh ) ? 0 : 1
  })

export default class ResizeProvider extends React.Component {

  constructor( props ) {
    super( props );
    this.state = {
      sw: 0,
      sh: 0
    }
  }

  componentDidMount() {
    this.setupResizeListener();
  }

  componentWillUnmount() {
    console.log('WARNING - RESIZE CONTEXT - UN MOUNT TRIGGERED')
  }

  setupResizeListener = () => {
    window.addEventListener('resize', this.handleResize);
    this.handleResize(); // call it once manually
  }

  handleResize = () => {
    this.setState({
      sw: window.innerWidth,
      sh: window.innerHeight
    })
  }

  render() {
    return (
      <Provider value={this.state}>
        {this.props.children}
      </Provider>
    )
  }

}



// WEBPACK FOOTER //
// ./src/Context/ResizeContext.js